import { withStyles, FormLabel as _FormLabel } from '@material-ui/core';
import { COLOR_TEXT_MAIN } from '../../../theme/colors';

const StyledFormLabel = withStyles({
  root: {
    fontWeight: 800,
    fontSize: '12px',
    color: COLOR_TEXT_MAIN,
    marginBottom: '12px',
    textAlign: 'start',
    '&.Mui-focused': {
      color: COLOR_TEXT_MAIN,
    },
  },
})(_FormLabel);

export default StyledFormLabel;
